import { useState, useEffect } from 'react';

/**
 * 延遲設定元件的顯示/隱藏狀態

 * 這個是給中間媒介的，如果中間還有設置一層自訂的元件，需要用這個來控制 visible 參數傳入

 * 預設延遲時間長度：300 毫秒（antd 元件動畫皆為 300 毫秒）

 * 範例：
 * ```tsx
 * export default function DrawerDelayedToShowEmail(props: {
 *   drawer_visible: 1 | undefined;
 *   set_drawer_visible: React.Dispatch<React.SetStateAction<1 | undefined>>;
 * }) {
 *   const { set_drawer_visible } = useMemo(() => props, [props]);

 *   return (
 *      <Drawer
 *        ......
 *        visible={!!VisibleDelayedInner(props.drawer_visible)}
 *      >
 *        ......
 *      </Drawer>
 *   );
 * }
 * ```
 */
const VisibleDelayedInner = (visible: 1 | undefined) => {
  const [visible_delayed, set_visible_delayed]: [1 | undefined, React.Dispatch<React.SetStateAction<1 | undefined>>] = useState<1 | undefined>();

  useEffect((): void => {
    setTimeout(() => {
      visible ? set_visible_delayed(1) : set_visible_delayed(undefined);
    }, 0);
  }, [visible]);

  return visible_delayed;
};

export default VisibleDelayedInner;
